import { ODataSelect } from "../../../../Providers.Api/ODataQuery";
import { DateTime } from "luxon";
import { DateHelper } from "../../../../Common/DateHelper";
import { Status } from "../../../../Components/Miscellaneous/BookingStatus/BookingStatus";

export class Visit extends ODataSelect
{
    public Node_Id = 0;
    public Space_Name = "";
    public Space_Id = "";
    public Visit_Id = "";
    public Visit_Start_Date = DateHelper.null();
    public Visit_End_Date = DateHelper.null();
    public Visit_Host_Name = "";
    public Visit_Status: VisitStatus = "New";
    public Visitor_First_Name = "";
    public Visitor_Last_Name = "";
    public Visitor_Email = "";
    public Visitor_Company = "";
    public _CreatedBy = "";
    public Visit_Pacs_Id = "";
    public CheckInWorkflow = "";

    public init(response: any, nodeId: number): Visit
    {
        super.init(response, nodeId);
        this.Visit_Start_Date = DateHelper.fromIsoByNode(response.Visit_Start_Date, response.Node_Id);
        this.Visit_End_Date = DateHelper.fromIsoByNode(response.Visit_End_Date, response.Node_Id);
        return this;
    }

}

export interface IVisitView
{
    Node_Id: number;
    Visit_Id: string;
    Visitor_Email: string;
    Visitor_First_Name: string;
    Visitor_Last_Name: string;
    Visit_Start_Date: DateTime;
    Visit_End_Date: DateTime;
    Visit_Host_Name: string;
    Visit_Status: VisitStatus;
    Space_Id: string;
    Space_Name: string;
    Booking_Id: string;
    Visit_Pacs_Id: string;
    Visitor_Company: string;
    CheckInWorkflow: string;
}



export type VisitStatus = "New" | "Amended" | "Late Checkin" | "Awaiting Approval" | "Approved" | "Checked In" | "Checked Out" | "Cancelled" | "Completed" | "No Show" | "Auto Cancelled" | "Denied";